import React, { useEffect, useState } from 'react';

import { headersFornecedores as headerTable } from './Fornecedores/Fornecedores/auxiliarFornecedores';
import {
  valoresExibidosFornecedor as valoresExibidos,
  fieldObjectFornecedor as fieldObject,
} from './Fornecedores/Fornecedores/auxiliarFornecedores';
import SubAbas from './subabas';
import { MunicipioIbge } from './types';
import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../components/BarraSubAbas';
import BoxConteudo from '../../../components/BoxConteudo';
import ContainerConteudo from '../../../components/ContainerConteudo';
import CustomButton from '../../../components/CustomButton';
import CustomCol from '../../../components/CustomCol';
import CustomRow from '../../../components/CustomRow';
import Input from '../../../components/InputNew';
import Select from '../../../components/InputNew/Select';
import Tabela from '../../../components/Tabela';
import WorkspaceBotoes from '../../../components/WorkspaceBotoes';
import { getUser } from '../../../modules/contexts/Auth/RequireAuth';
import { useHierarquia } from '../../../services/enum/useHierarquia';
import { usePorte } from '../../../services/enum/usePorte';
import {
  getAllFornecedores,
  getAllMunicipiosIbge,
} from '../../../services/fornecedoresDAF/fornecedorService';
import httpClient from '../../../services/httpClient';
import { ENTITY } from '../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../utils/functions';

//Dados do usuário
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_Fornecedor;

const FornecedoresIndex: React.FC = () => {
  // Verificar permissões para ações
  const canDownload = true;

  //PERMISSOES

  const Hierarquia = useHierarquia();
  const Porte = usePorte();

  //Dados do módulo
  const [data, setData] = useState<any[]>([]);
  const [municipioIbgeData, setMunicipioIbgeData] = useState<MunicipioIbge[]>(
    [],
  );
  const [ufIndex, setUfIndex] = useState<string>('0');

  //Filtro
  const [formFiltros, setFormFiltros] = useState({
    hierarquia: 0,
    porte: 0,
    uf: '',
    cnpj: '',
    razaoSocial: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Buscar os vínculos do usuário logado
        const vinculoResponse = await httpClient.get(`/api/usuariointerface`, {
          params: {
            coUsuario: userID,
            stRegistroAtivo: 'S',
          },
        });

        const vinculoData = vinculoResponse.data;
        const cnpjsVinculados =
          vinculoData.relacoes?.map((v: any) => v.cnpj?.replace(/\D/g, '')) ||
          [];

        // 2. Buscar todos os fornecedores
        const fornecedoresData = await getAllFornecedores();
        const municipioIbgeData = await getAllMunicipiosIbge();

        // 3. Filtrar apenas os fornecedores vinculados
        const fornecedoresFiltrados = fornecedoresData.filter((f: any) => {
          const cnpjFornecedor = f.cnpj?.replace(/\D/g, '');
          return cnpjsVinculados.includes(cnpjFornecedor);
        });

        setData(fornecedoresFiltrados);
        setMunicipioIbgeData(municipioIbgeData);
      } catch (error) {
        console.error('Erro ao carregar fornecedores vinculados:', error);
      }
    };

    fetchData();
  }, []);

  const tableData = data
    .map((registro) => ({
      id: registro.id,
      cnpj: registro.cnpj,
      hierarquia: Hierarquia[registro.hierarquia].label,
      porte: Porte[registro.porte].label,
      // direito: registro.naturezaJuridica.naturezaJuridica,
      uf: registro.municipioIbge.ufSigla,
      fornecedor: registro.razaoSocial,
    }))
    .filter((registro: any) => {
      return (
        (formFiltros.hierarquia === 0 ||
          registro.hierarquia === Hierarquia[formFiltros.hierarquia].label) &&
        (formFiltros.porte === 0 ||
          registro.porte === Porte[formFiltros.porte].label) &&
        (formFiltros.uf === '' ||
          registro.uf.toLowerCase().includes(formFiltros.uf.toLowerCase())) &&
        (formFiltros.cnpj === '' ||
          registro.cnpj
            .toLowerCase()
            .includes(formFiltros.cnpj.toLowerCase())) &&
        (formFiltros.razaoSocial === '' ||
          registro.fornecedor
            .toLowerCase()
            .includes(formFiltros.razaoSocial.toLowerCase()))
      );
    });

  const offCanvasData = data.map((registro) => ({
    // Atributos de logs
    id: registro.id,
    dataRegistro:
      formatDate(registro.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(registro.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(registro.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(registro.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(registro.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(registro.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: registro.nEdicoes,
    nVisualizacoes: registro.nVisualizacoes,
    separadorLog: '',
    cnpj: <b>{registro.cnpj}</b>,
    razaoSocial: <b>{registro.razaoSocial}</b>,
    nomeFantasia: registro.nomeFantasia,
    hierarquia: Hierarquia[registro.hierarquia].label,
    porte: Porte[registro.porte].label,
    dataAbertura: formatDateSimp(registro.dataAbertura),
    separadorContato: '',
    telefone1: registro.telefone1,
    telefone2: registro.telefone2,
    email: registro.email,
    site: registro.site,
    separadorCEP: '',
    cep: registro.cep,
    bairro: registro.bairro,
    logradouro: registro.logradouro,
    numeroImovel: registro.numeroImovel,
  }));

  const ufOptions = [
    { value: 0, label: ' - ' },
    ...municipioIbgeData
      .filter(
        (item, index, self) =>
          // Filtra apenas os itens cujas labels são únicas
          index === self.findIndex((i) => i.ufSigla === item.ufSigla),
      )
      .sort((a, b) => a.ufSigla.localeCompare(b.ufSigla))
      .map((item, index) => ({
        value: index + 1,
        label: item.ufSigla,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  ];

  //Funções Handle
  // const handleInserir = () => {
  //   navigate('ficha/dadosgerais');
  // };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);
    if (name === 'hierarquia') {
      setFormFiltros({
        ...formFiltros,
        hierarquia: newValue,
      });
    } else if (name === 'uf') {
      const uf = ufOptions.find((option) => option.value.toString() === value);
      setUfIndex(value);
      if (uf) {
        setFormFiltros({
          ...formFiltros,
          uf: uf.label,
        });
      }
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      hierarquia: 0,
      porte: 0,
      uf: '',
      cnpj: '',
      razaoSocial: '',
    });
    setUfIndex('0');
  };

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="20%">
              <Input
                id="cnpj"
                name="cnpj"
                value={formFiltros.cnpj}
                label="CNPJ"
                onChange={handleChange}
              />
            </CustomCol>

            <CustomCol width="10%">
              <Select
                name="uf"
                value={ufIndex}
                options={ufOptions}
                onChange={handleChange}
                label="UF"
              />
            </CustomCol>
            <CustomCol width="15%">
              <Select
                name="hierarquia"
                value={formFiltros.hierarquia}
                options={Hierarquia}
                onChange={handleChange}
                label="Hierarquia"
              />
            </CustomCol>
            <CustomCol width="15%">
              <Select
                name="porte"
                value={formFiltros.porte}
                options={Porte}
                onChange={handleChange}
                label="Porte"
              />
            </CustomCol>
            <CustomCol width="40%">
              <Input
                id="razaoSocial"
                name="razaoSocial"
                value={formFiltros.razaoSocial}
                label="Fornecedor"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>
        <Tabela
          headers={headerTable}
          dataRaw={data}
          dataTable={tableData}
          displayValues={valoresExibidos}
          dataOffCanvas={offCanvasData}
          tituloCanvas="FORNECEDOR"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          downloadDisabled={!canDownload}
          onClickDownload={() =>
            ExportToExcel(
              data,
              valoresExibidos,
              fieldObject,
              'fornecedores.xlsx',
              userID,
              'DAF',
              entity,
            )
          }
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default FornecedoresIndex;
